// extracted by mini-css-extract-plugin
export default {"container":"terms_container__3RqX3","spacer":"terms_spacer__PsI0z","heading":"terms_heading__0jnBp"};